<template>
    <v-sheet class="page-container">
        <div class="sheet-content" id="viewer" ref="sheetContent"></div>
    </v-sheet>
</template>

<script>

import "../musicxml-vexflow.js";

import axios from "axios";

export default {
  name: "SheetShowPreview",
  data: function() { return {} },
  mounted() {
    console.log('SheetShowPreview mounted');
        const xmlString = this.$store.getters.currentMusicXML;
    // setTimeout(() => {
        const sheetContent = this.$refs.sheetContent;
        window.MusicScoreController.viewPortPadding = 100000;
        // debugger;
        window.MusicScoreController.shareInstance = new window.MusicScoreController(sheetContent);
        window.MusicScoreController.shareInstance.loadDataWithXMLString({xmlStr: xmlString});
        window.MusicScoreController.shareInstance.shallowTraversal();
        window.MusicScoreController.shareInstance.shallowTraversalToCheckDirection();
        window.MusicScoreController.shareInstance.deepTraversal();
    // }, 1000)

  },
  created: function() {},

  methods: {}
};
</script>

<style scoped>

.page-container {
  padding: 30px;
}

.sheet-content {
  width: 100%;
  margin-left: -18px;
}
</style>
